import { createMMKV } from 'react-native-mmkv';

// MMKV storage instance for the configuration domain (user/app preferences:
// column visibility, column ordering, etc.).
export const configurationStorage = createMMKV({
  id: 'configuration-storage',
});

export const STORAGE_KEYS = {
  COLUMN_PREFERENCES: 'column_preferences',
};
